import Card from '../Card';

export default function CaregiverMetricsOverviewView() {
  return (
    <Card titleI18nKey="metrics" additionalClass="x-large">
      Metrics TODO
    </Card>
  );
}
